import { Password } from "@equidefi/ui/forms";
import type { PasswordProps } from "@equidefi/ui/forms/Password";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartPasswordProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<PasswordProps, "name" | "label"> & {
  name: TName;
  label?: string;
  isRequired?: boolean;
};

function SmartPassword<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, isRequired, ...passwordProps }: SmartPasswordProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({
    name,
    control,
  });

  return (
    <Password
      {...field}
      label={label as string}
      isInvalid={!!error}
      isRequired={isRequired}
      error={error?.message}
      {...passwordProps}
    />
  );
}

export default SmartPassword;
